// TODO: error and cancelled not implemented
export var JobStatus;
(function (JobStatus) {
    JobStatus["Running"] = "running";
    JobStatus["Done"] = "done";
    JobStatus["Error"] = "error";
    JobStatus["Cancelled"] = "cancelled";
})(JobStatus || (JobStatus = {}));
